import { render, staticRenderFns } from "./service-support-title.vue?vue&type=template&id=0903d174&"
import script from "./service-support-title.vue?vue&type=script&lang=js&"
export * from "./service-support-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports